import * as types from './mutation-types'
import {
  getTransporteurs,
  postTransporteur,
  deleteTransporteur,
  getOptionsTransporteur,
  moveTransporteur
} from '../../../api/transporteur'
import {
  getForfaitsTransport
} from '../../../api/forfaitTransport'
import {
  getTypesClient
} from '../../../api/client'

const getInitialState = () => {
    return {
      transporteurs: {},
      forfaits: {},
      parametrages: [],
      options: [],
      currentTransporteur: {}
    }
}

const state = { ...getInitialState() }

const mutations = {
    [types.ADD_TRANSPORTEUR](state, newTransporteur) {
        state.transporteurs = {
          ...state.transporteurs,
          [newTransporteur.position]: newTransporteur
        }
    },
    [types.SET_FORFAITS](state, listeForfaits) {
        state.forfaits = listeForfaits
    },
    [types.SET_OPTIONS_TRANSPORTEUR](state, options) {
        state.options = options
    },
    [types.SET_TYPES_CLIENT](state, parametrages) {
        state.parametrages = parametrages
    },
    [types.SET_TRANSPORTEURS](state, listeTransporteurs) {
        state.transporteurs = listeTransporteurs
    },
    [types.DELETE_TRANSPORTEUR](state, transporteurId) {
        delete state.transporteurs[transporteurId]
        state.transporteurs = {
          ...state.transporteurs
        }
    }
    // [types.UPDATE_TRANSPORTEUR](state, transporteur) {
    //     state.transporteurs[transporteur.position] = transporteur
    // },
}

const actions = {
    async createTransporteur({ commit, state }, transporteur) {
        const transporteurRemote = await postTransporteur(transporteur)
        commit(types.ADD_TRANSPORTEUR, transporteurRemote)
    },
    async setTransporteurs({ commit }) {
        const listeTransporteurs = await getTransporteurs()
        commit(types.SET_TRANSPORTEURS, listeTransporteurs)
    },
    async deleteTransporteur({ commit, state }, position) {
        await deleteTransporteur(position)
        commit(types.DELETE_TRANSPORTEUR, position)
    },
    async setForfaits({ commit }) {
        const listeForfaits = await getForfaitsTransport()
        commit(types.SET_FORFAITS, listeForfaits)
    },
    async setParametrages({ commit }) {
        const parametrages = await getTypesClient()
        commit(types.SET_TYPES_CLIENT, parametrages)
    },
    async setOptionsTransporteur({ commit }) {
        const optionsTransporteur = await getOptionsTransporteur()
        commit(types.SET_OPTIONS_TRANSPORTEUR, optionsTransporteur)
    }
    // async moveTransporteur({ commit, state }, event) {
    //     const listeTransporteurs = await moveTransporteur(event)
    //     commit(types.SET_TRANSPORTEURS, listeTransporteurs)
    // },
    // async updateTransporteur({ commit, state }, newTransporteur) {
    //     const transporteurRemote = await postTransporteur(newTransporteur)
    //     commit(types.UPDATE_TRANSPORTEUR, transporteurRemote)
    // }
}

const getters = {
    transporteurs: state => state.transporteurs,
    forfaits: state => state.forfaits,
    parametrages: state => state.parametrages,
    options: state => state.options,
    currentTransporteur: state => state.currentTransporteur
}

export default { state, mutations, actions, getters }
